/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  TextField,
  Typography,
  Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import useContact from './useContact';
import { checkErrors } from '../../../../helpers/utils';

const useStyles = makeStyles(() => ({
  container: {
    marginBottom: '50px',
    width: '100%',
  },
}));

const NewContact = ({ companyId, pedagogicData, setPedagogicData }) => {
  const { addContact } = useContact(companyId, pedagogicData, setPedagogicData);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    name: '',
    firstname: '',
    phone: '',
    mail: '',
  });
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography
        component="h6"
        variant="h6"
      >
        Informations du référent
      </Typography>
      <Grid container spacing={2}>
        <Grid item md={4}>
          <TextField
            label="Nom"
            variant="outlined"
            margin="normal"
            error={errors.name}
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            fullWidth
          />
        </Grid>
        <Grid item md={4}>
          <TextField
            label="Prénom"
            variant="outlined"
            error={errors.firstname}
            margin="normal"
            value={form.firstname}
            onChange={(e) => setForm({ ...form, firstname: e.target.value })}
            fullWidth
          />
        </Grid>
        <Grid item md={4}>
          <TextField
            label="Numéro de téléphone"
            variant="outlined"
            error={errors.phone}
            margin="normal"
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item md={7}>
          <TextField
            label="Email"
            variant="outlined"
            error={errors.mail}
            margin="normal"
            value={form.mail}
            onChange={(e) => setForm({ ...form, mail: e.target.value })}
            fullWidth
          />
        </Grid>
        <Grid item md={1} />
        <Grid item md={4}>
          <Button
            onClick={() => {
              const error = checkErrors(form, setErrors);
              if (error) {
                return;
              }
              addContact(form, setForm);
            }}
            style={{ marginTop: '1em', padding: '1em 0 1em 0' }}
            variant="contained"
            color="primary"
            fullWidth
          >
            + Ajouter
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

NewContact.propTypes = {
  pedagogicData: PropTypes.array.isRequired,
  setPedagogicData: PropTypes.func.isRequired,
  companyId: PropTypes.string.isRequired,
};

export default NewContact;
